export default __webpack_public_path__ + "static/media/Banner2.d35c8837.jpg";